export const RESET_RESERVATION_ISFETCHING = 'RESET_RESERVATION_ISFETCHING';
export const GET_RESERVATION_REQUEST = 'GET_RESERVATION_REQUEST';
export const GET_RESERVATION_SUCCESS = 'GET_RESERVATION_SUCCESS';
export const LIST_RESERVATIONS_REQUEST = 'LIST_RESERVATIONS_REQUEST';
export const LIST_RESERVATIONS_SUCCESS = 'LIST_RESERVATIONS_SUCCESS';
export const RESERVATION_LIST_REQUESTING = 'RESERVATION_LIST_REQUESTING';
export const RESERVATION_OBJECT_REQUESTING = 'RESERVATION_OBJECT_REQUESTING';
export const CANCEL_RESERVATION_REQUEST = 'CANCEL_RESERVATION_REQUEST';
